import Vue from 'vue'
import numeral from "numeral";

Vue.filter('price', (value) => {
    return value && !isNaN(value) ? numeral(value).format('0,0.00') : "0.00";
});
Vue.filter('human', (value) => {
    return value && !isNaN(value) ? numeral(value).format('0.0a').toUpperCase() : "0";
});
Vue.filter('integer', (value) => {
    return value && !isNaN(value) ? numeral(value).format('0,0') : "0";
});
